module.exports = __webpack_public_path__ + "static/media/cz.789e10f9.svg";